import {
    endOfMonth,
    endOfWeek,
    endOfYear,
    startOfMonth,
    startOfWeek,
    startOfYear,
    subMonths,
    subWeeks,
    subYears,
} from 'date-fns'

import getReportName, { IReport } from '../../../lib/getReportName'
import { downloadFile } from '../../../common/services/fileDownloader'

export type PeriodInterval =
    | 'CurrentWeek'
    | 'PreviousWeek'
    | 'CurrentMonth'
    | 'PreviousMonth'
    | 'CurrentYear'
    | 'PreviousYear'

export type IntervalDatesType = {
    fromDate: Date
    toDate: Date
}

export const getDatesForInterval = (interval: PeriodInterval): IntervalDatesType | undefined => {
    let intervalStart
    let fromDate
    let toDate

    switch (interval) {
        case 'CurrentWeek':
            fromDate = startOfWeek(new Date())
            toDate = endOfWeek(new Date())
            break
        case 'PreviousWeek':
            intervalStart = subWeeks(new Date(), 1)
            fromDate = startOfWeek(intervalStart)
            toDate = endOfWeek(intervalStart)
            break
        case 'CurrentMonth':
            fromDate = startOfMonth(new Date())
            toDate = endOfMonth(new Date())
            break
        case 'PreviousMonth':
            intervalStart = subMonths(new Date(), 1)
            fromDate = startOfMonth(intervalStart)
            toDate = endOfMonth(intervalStart)
            break
        case 'CurrentYear':
            fromDate = startOfYear(new Date())
            toDate = endOfYear(new Date())
            break
        case 'PreviousYear':
            intervalStart = subYears(new Date(), 1)
            fromDate = startOfYear(intervalStart)
            toDate = endOfYear(intervalStart)
            break
        default:
            return
    }

    return {
        fromDate,
        toDate,
    }
}

export const generateReports = (report: IReport, fromDate: string, toDate: string) => {
    const reportName = getReportName(report, fromDate, toDate)

    let csvData = '\ufeff' + report.formattedData
    if (!report.formattedData || report.formattedData.length === 0) {
        csvData += 'N/A'
    }

    downloadFile(reportName, 'csv', csvData)
}
